module.exports = __webpack_public_path__ + "img/c06_unitlancer_Normal_ua.cdb0a6be.webp";